import React, { useContext } from "react";

import PropTypes from "prop-types";

import { useEnableDotcomMapbox } from "components/hooks/feature-flags";
import { PropertyListingContext, useBootstrap } from "components/store/source";
import { GoogleMap, Header, Section, Text } from "components/ui/source";

import { StaticMap } from "../../mapbox/StaticMap";

import InfoTilesGrid from "./InfoTilesGrid";

import styles from "./Neighborhood.module.scss";

function Neighborhood({ id, className }) {
  const { listing } = useContext(PropertyListingContext);

  return (
    <Section id={id} className={className}>
      <Header
        className={styles.title_header}
        size="md"
        type="headline3"
        translateKey="listing:neighborhood.title"
      />
      <NeighborhoodMap listing={listing} />

      {listing?.neighborhoodName && (
        <Header
          className={styles.neighborhood_name}
          size="sm-md"
          type="headline4"
        >
          {listing?.neighborhoodName}
        </Header>
      )}
      {listing?.neighborhoodDescription && (
        <Text className={styles.neighborhood_decription} types={["body1"]}>
          {listing?.neighborhoodDescription}
        </Text>
      )}
      <InfoTilesGrid />
    </Section>
  );
}

const NeighborhoodMap = ({ listing }) => {
  const { urlParams } = useBootstrap();
  const enableDotcomMapbox = useEnableDotcomMapbox(urlParams?.city);

  if (listing?.geocode) {
    if (enableDotcomMapbox) {
      return (
        <StaticMap center={listing.geocode} className={styles.map_container} />
      );
    } else {
      return (
        <GoogleMap
          center={listing?.geocode}
          containerClass={styles.map_container}
          mapClass={styles.map}
        >
          <GoogleMap.Marker position={listing?.geocode} />
        </GoogleMap>
      );
    }
  }

  return null;
};

Neighborhood.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
};

export default Neighborhood;
